export const option1 = [
  { label: 'Style', value: 'style' },
  { label: 'Focal Length', value: 'focalLength' },
  { label: 'Lighting', value: 'lighting' },
  { label: 'Distance', value: 'distance' },
  { label: 'Details', value: 'details' },
]

export const socialMediaLinks = [
  { id: '1', label: 'Facebook', icon: 'facebook', link: 'https://www.facebook.com', target: '_blank' },
  { id: '2', label: 'Instagram', icon: 'instagram', link: 'https://www.instagram.com', target: '_blank' },
  { id: '3', label: 'Twitter', icon: 'twitter', link: 'https://www.twitter.com', target: '_blank' },
]
export const showAspectRatioData = [
  { value: '1:1', label: 'Square', width: '1024', height: '1024' },
  { value: '2:3', label: 'Portrait', width: '640', height: '960' },
  { value: '4:5', label: 'Social Post', width: '512', height: '640' },
  { value: '3:2', label: 'Standard', width: '960', height: '640' },
  { value: '5:4', label: 'Rectangular', width: '640', height: '512' },
  { value: '9:16', label: 'Social Story', width: '576', height: '1024' },
  { value: '16:9', label: 'Widescreen', width: '1024', height: '576' },
]
